export function calculateOpportunityTdc(projectUses: { [key: string]: string }) {
  let total = 0;
  Object.keys(projectUses).forEach((use) => {
    total += +projectUses[use];
  });
  return total;
}
